<template>
  <div>
    <table class="table is-bordered">
      <thead :style="`background: ${local_clipart_table.styles.bg_color}`">
        <tr>
          <th
            :style="`color: ${local_clipart_table.styles.font_color}`"
            align="center"
            colspan="2"
          >
            {{ local_clipart_table.title }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(clips, row_index) in local_clipart_table.properties"
          :key="`CLIPS${row_index}`"
        >
          <td
            :style="
              `background: ${clips.styles.bg_color};color: ${clips.styles.font_color}`
            "
          >
            {{ clips.title }}
          </td>
          <td @mouseleave="mouseLeaveTd(row_index)">
            <div class="clipart-show-row">
              <div
                v-for="(clip, clip_index) in clips.num_images"
                :key="`CLIP${clip_index}`"
                @click="shadeMeUptoClicked(row_index, clip_index)"
                class="mx-1"
                @mouseover.prevent="shadeMeUptoHover(row_index, clip_index)"
              >
                <show-clipart
                  :class="
                    clips.is_user_selectable
                      ? handleColorClipart(row_index, clip_index)
                      : 'is-colored'
                  "
                  :clipart="clips.clipart"
                ></show-clipart>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ShowClipart from "@/components/Question/Clipart/ShowClipart";
import { mapActions } from "vuex";
export default {
  name: "show-clipart-table",
  props: {
    clipart_table: {
      type: Object,
    },
  },
  components: {
    ShowClipart,
  },
  data() {
    return {
      local_clipart_table: this.clipart_table,
      user_selections: {},
      user_hover_selection: {},
    };
  },
  methods: {
    ...mapActions(['updateCurrentAnswer']),
    mouseLeaveTd(row_index) {
      this.$set(
        this.user_hover_selection,
        row_index,
        this.user_selections[row_index]
      );
    },
    handleColorClipart(row_index, clip_index) {
      if (
        !this.isLight(row_index, clip_index) &&
        this.isHovered(row_index, clip_index)
      ) {
        return "is-colored";
      } else if (
        this.isLight(row_index, clip_index) &&
        this.isHovered(row_index, clip_index)
      ) {
        return "is-colored";
      } else if (
        this.isLight(row_index, clip_index) &&
        !this.isHovered(row_index, clip_index)
      ) {
        return "is-light-colored";
      } else {
        return "is-light";
      }
    },
    shadeMeUptoHover(row_index, clip_index) {
      if (this.local_clipart_table.properties[row_index].is_user_selectable) {
        this.$set(this.user_hover_selection, row_index, clip_index);
      }
    },
    isHovered(row_index, clip_index) {
      let hoveredUpto = this.user_hover_selection[row_index];
      if (clip_index <= hoveredUpto) {
        return true;
      }
      return false;
    },
    shadeMeUptoClicked(row_index, clip_index) {
      if (this.local_clipart_table.properties[row_index].is_user_selectable) {
        this.$set(this.user_selections, row_index, clip_index);
      }
      this.checkAnswers();
    },
    isLight(row_index, clip_index) {
      let coloredUpto = this.user_selections[row_index];
      if (clip_index <= coloredUpto) {
        return true;
      }
      return false;
    },
    checkAnswers() {
      let is_correct = false;
      let rows = this.local_clipart_table.properties;
      let matched_answers = 0;
      let total_answers = this.getTotalAnswers;

      for (let row_index in rows) {
        const row = rows[row_index];
        if (
          row.is_user_selectable &&
          this.user_selections[row_index] === row.answer - 1
        ) {
          matched_answers += 1;
        }
      }

      if (matched_answers == total_answers) {
        is_correct = true;
      } else {
        is_correct = false;
      }

      this.updateCurrentAnswer({ key : "clipart_table", value : is_correct })
    },
  },
  computed: {
    getTotalAnswers() {
      return this.local_clipart_table.properties.filter(
        (clip) => clip.is_user_selectable
      ).length;
    },
  },
  watch: {
    clipart_table: {
      handler: function(new_val) {
        this.local_clipart_table = new_val;
      },
    },
  },
};
</script>

<style scoped>
.clipart-show-row {
  display: flex;
}
.is-light {
  opacity: 0.4;
}
.is-colored {
  opacity: 1;
}
.is-light-colored {
  opacity: 0.8 !important;
}
</style>
